export function Privacy () {
  return <div className="min-h-screen bg-gradient-to-b from-black via-black/80 to-yellow-500 bg-fixed">
    <header className="bg-black text-yellow-400 py-3 sm:py-5 shadow-lg border-b border-yellow-400/60">
      <h1>Privacy</h1>
    </header>
  </div>
}
